import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "q-py-sm q-px-md text-white bg-primary" }
const _hoisted_2 = { class: "q-px-md q-py-md text-off-black" }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 1,
  class: "q-px-md q-pb-md"
}

import { storeToRefs } from 'pinia';
import { Dialog, QBtn, useDialogPluginComponent } from 'quasar';
import { computed, nextTick, onMounted, Ref, ref } from 'vue';
import { useAuthStore } from '#src/store/auth';
import { ACTION_TYPES, useHistoryStore } from '#src/store/history';
import { useUserStore } from '#src/store/user';
import AddNoteForm from 'components/history/AddNoteForm.vue';
import ErrorBanner from 'components/ErrorBanner.vue';
import SimpleDialog from 'components/SimpleDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImpersonationDialog',
  props: {
    userKey: null
  },
  setup(__props: any) {

const props = __props as { userKey: string };

const historyStore = useHistoryStore();
const { isSavingNote } = storeToRefs(historyStore);



const { dialogRef, onDialogCancel, onDialogOK } = useDialogPluginComponent();

const userStore = useUserStore();
const { users } = storeToRefs(userStore);

const { isT3 } = storeToRefs(useAuthStore());

const user = computed(() => users.value[props.userKey]);

const hasBetaUrl = computed(() => Boolean(process.env.WEB_V3_BETA_URL));

const notesEntered = ref(false);
function onInput(_: KeyboardEvent, value: string) {
  notesEntered.value = Boolean(value.trim());
}

const impersonationAllowed: Ref<boolean | null> = ref(null);
const impersonationError = ref('');
onMounted(async () => {
  resetStatus();
  try {
    await userStore.impersonatePrecheck(props.userKey);
    impersonationAllowed.value = true;
  } catch (error) {
    impersonationAllowed.value = false;
    impersonationError.value = (<Error>error).message;
    return;
  }
});

function onSave() {
  if (usedButton.value) {
    // Nothing to do, notes saved and window opened
    onDialogOK();
    return;
  }

  // Handle note save (from user hitting Enter vs. clicking a button)
  async function openImpersonationWindow() {
    const windowReference = window.open(
      `/api/user/${props.userKey}/impersonate`,
      '_blank'
    );

    await nextTick();

    if (!windowReference) {
      Dialog.create({
        component: SimpleDialog,
        componentProps: {
          title: 'Popup Blocked',
          message:
            'You must allow popups in this browser to open the impersonation window. Once allowed, press "Continue" to begin impersonation.',
          okText: 'Continue',
          dismissText: 'Cancel',
          prompt: true,
        },
      }).onOk(openImpersonationWindow);
    }
  }

  openImpersonationWindow();
  onDialogOK();
}

const addNoteForm: Ref<typeof AddNoteForm | null> = ref(null);
const didSave = ref(false);
const usedButton = ref(false);
const usingBeta = ref(false);
async function onImpersonate(beta?: boolean) {
  usedButton.value = true;
  usingBeta.value = Boolean(beta);
  await nextTick();
  addNoteForm.value?.addNote();
}

function resetStatus() {
  didSave.value = false;
  usedButton.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-dialog__title q-pa-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, " Impersonate: " + _toDisplayString(_unref(user).firstName) + " " + _toDisplayString(_unref(user).lastName), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            (impersonationAllowed.value === null)
              ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                  key: 0,
                  indeterminate: "",
                  size: "lg"
                }))
              : (impersonationAllowed.value === false)
                ? (_openBlock(), _createBlock(ErrorBanner, {
                    key: 1,
                    message: impersonationError.value
                  }, null, 8, ["message"]))
                : (impersonationAllowed.value === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, " You are about to impersonate " + _toDisplayString(_unref(user).firstName) + " " + _toDisplayString(_unref(user).lastName) + _toDisplayString(_unref(user).email ? ` (${_unref(user).email})` : '') + ". Please leave a brief note explaining the reason for this impersonation. ", 1))
                  : _createCommentVNode("", true)
          ]),
          (impersonationAllowed.value !== true)
            ? (_openBlock(), _createBlock(_component_q_card_actions, {
                key: 0,
                align: "right",
                class: "q-pt-none q-pb-md q-px-md"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_unref(QBtn), {
                    color: "white",
                    label: "Dismiss",
                    padding: "xs md",
                    "text-color": "off-black"
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              }))
            : (impersonationAllowed.value === true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(AddNoteForm, {
                    ref_key: "addNoteForm",
                    ref: addNoteForm,
                    "action-type": _unref(ACTION_TYPES).IMPERSONATION,
                    autosave: false,
                    flat: "",
                    "note-details": `Impersonating ${_unref(user).email}${usingBeta.value ? ' on Beta' : ''}`,
                    "user-key": __props.userKey,
                    onCancel: _unref(onDialogCancel),
                    onError: _cache[2] || (_cache[2] = ($event: any) => (resetStatus())),
                    onInput: onInput,
                    onSave: onSave
                  }, {
                    actions: _withCtx(() => [
                      (_unref(isT3) && _unref(hasBetaUrl))
                        ? (_openBlock(), _createBlock(_unref(QBtn), {
                            key: 0,
                            class: "q-ml-sm",
                            color: "primary",
                            disable: !notesEntered.value,
                            href: `/api/user/${props.userKey}/impersonate?beta=yes`,
                            loading: _unref(isSavingNote),
                            target: "_blank",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (onImpersonate(true)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Log In (Beta)")
                            ]),
                            _: 1
                          }, 8, ["disable", "href", "loading"]))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(QBtn), {
                        color: "primary",
                        disable: !notesEntered.value,
                        href: `/api/user/${props.userKey}/impersonate`,
                        loading: _unref(isSavingNote),
                        target: "_blank",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onImpersonate()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Log In")
                        ]),
                        _: 1
                      }, 8, ["disable", "href", "loading"])
                    ]),
                    _: 1
                  }, 8, ["action-type", "note-details", "user-key", "onCancel"])
                ]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})